import React from 'react'
import Header from '../compontents/Header'
import Footer from '../compontents/Footer'
import ContantUs from '../compontents/ContantUs'

const ContentPage = () => {
  return (
    <React.Fragment>
      <Header />
      <ContantUs />
      <Footer />
    </React.Fragment>
  )
}

export default ContentPage